import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import * as Actions from 'flex/Actions';
import { useAppSelector } from 'flex/utils';

type CallbackFn = (meta: unknown, payload: unknown, isControl: boolean) => void

type ClassState = {
    isLoading: boolean
    itemCount: number
    list: SchoolClass[]
    pageSize: number
    pageTotal: number
}

const useSchoolClass = (
    // ここでは引数は使わないが、他でここの実装を真似する際のためにそれっぽくしておく
    successCallback: CallbackFn = () => undefined,
    failureCallback: CallbackFn = () => undefined,
) => {
    const dispatch = useDispatch();
    const [state, setState] = useState<ClassState>({
        isLoading: false,
        itemCount: 0,
        list: [],
        pageSize: 0,
        pageTotal: 0,
    });

    const classSearchConnection = useAppSelector(state => state.classSearchConnection);

    useEffect(() => {
        const { meta, payload } = classSearchConnection;

        // 通信中でない === 画面遷移など意図しないタイミング
        if (!state.isLoading) return;

        switch (meta.status) {
            case Actions.statusEnum.SUCCESS: {
                successCallback(meta, payload, true);
                setState(state => ({
                    ...state,
                    isLoading: false,
                    itemCount: payload.result.item_count,
                    list: payload.result.items,
                    pageSize: payload.result.page_size,
                    pageTotal: payload.result.page_total,
                }));
                return;
            }
            case Actions.statusEnum.FAILURE:
            case Actions.statusEnum.ERROR: {
                failureCallback(meta, payload, true);
                setState(state => ({
                    ...state,
                    isLoading: false,
                }));
                return;
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [classSearchConnection]);

    type SearchParams = Partial<{
        page_size: number
        term_uuid: string
        organization_uuid: string
    }>;
    const request = useCallback((
        data: SearchParams = { },
        // eslint-disable-next-line @typescript-eslint/no-inferrable-types
        page: number = 1
    ) => {

        dispatch(Actions.http.connection.classes.search(data, page));
        setState(state => ({
            ...state,
            isLoading: true,
        }));

    }, [dispatch]);

    const reset = useCallback(() => {
        setState({
            isLoading: false,
            itemCount: 0,
            list: [],
            pageSize: 0,
            pageTotal: 0,
        });
    }, []);

    return [state, request, reset] as const;
};

export default useSchoolClass;
